import React from 'react';
import cn from 'classnames';

import Code from './Code';
import Json from './Json';
import Buttons from './Buttons';
import styles from './ExampleContent.module.css';

class ExampleContent extends React.Component {
  constructor(props) {
    super(props);
    this.renderExample = this.renderExample.bind(this);
    this.state = {
      json: false
    };
  }

  componentDidMount() {
    if (window.innerWidth < 992) {
      if (this.exampleElement) {
        // hack to show annotations on video examples
        this.exampleElement.onShowAnnotations();
      }
    }
  }

  changeCode() {
    this.setState({ json: true });
    if (this.exampleElement) {
      // hack to show annotations on video examples
      this.exampleElement.onShowAnnotations();
    }
  }

  renderExample() {
    if (this.props.example.component) {
      return (
        <this.props.example.component
          refAsync={_ref => {
            this.exampleElement = _ref;
          }}
          async
        />
      );
    }
    return <this.props.example async />;
  }

  render() {
    const {
      instruction,
      code,
      response,
      responseDelay,
      result,
      highlightedButton,
      landingHref,
      product,
      buttonText,
      color,
      theme = 'light',
      jsonResult = true
    } = this.props;
    const { json } = this.state;
    return (
      <>
        {instruction && (
          <p
            className={cn(
              styles.instruction,
              color.instruction,
              theme === 'dark'
                ? 'text-left sm:text-center sm:mt-7 sm:mb-10 mb-10 leading-8'
                : 'lg:my-10 mb-2 text-center',
              'text-lg'
            )}
          >
            {instruction}
          </p>
        )}
        <div
          className={cn(
            theme === 'dark' ? 'gap-10 xl:gap-10' : 'gap-10',
            'grid xl:grid-cols-2',
            product === 'Scale Text' ? styles.wrapperText : '',
            product === 'Scale Document' ? styles.wrapperDocument : '',
            product === 'Scale Image' ? styles.wrapperImage : ''
          )}
        >
          <div
            className={cn(
              styles.attachment,
              'rounded-lg',
              'relative md:rounded-lg shadow-md overflow-hidden min-w-0'
            )}
          >
            {json && result ? result : this.renderExample()}
          </div>
          <div className="relative text-sm lg:h-full min-w-0">
            <div
              className={cn(
                styles.codeContainer,
                'h-full relative shadow-md',
                theme === 'dark' ? 'bg-neutral-900 rounded-lg' : 'bg-white rounded-lg'
              )}
            >
              <Code theme={theme}>{code}</Code>
            </div>
            <Buttons
              hideRunCode={json}
              landingHref={landingHref}
              highlighted={highlightedButton}
              buttonText={buttonText}
              handleClick={e => {
                this.changeCode(e);
              }}
            />
            {json && jsonResult && <Json response={response} responseDelay={responseDelay} />}
          </div>
        </div>
      </>
    );
  }
}

ExampleContent.defaultProps = {
  landingHref: null,
  buttonText: 'Run code',
  color: {
    instruction: 'text-black'
  }
};

export default ExampleContent;
